import{Portal as o}from"radix-ui";const r=o.Root,P=o.Root;export{r as Portal,P as Root};
//# sourceMappingURL=portal.js.map
